import React, { useState } from "react";
import api from "@/lib/api";
import { Ticket, Loader2 } from "lucide-react";
import { toast } from "sonner";

export function VoucherRedeem({ onRedeemed }) {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    setBusy(true);
    try {
      const r = await api.post("/credits/redeem-voucher", { code: code.trim() });
      toast.success(`+${r.data.credits_added} kredit beváltva! Új egyenleg: ${r.data.balance}`);
      setCode("");
      onRedeemed?.(r.data.balance);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Sikertelen beváltás");
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="voucher-redeem-form" className="glass-strong rounded-3xl p-5 flex flex-wrap items-center gap-3 max-w-3xl mx-auto mt-4">
      <div className="flex items-center gap-3 flex-1 min-w-[240px]">
        <div className="w-10 h-10 rounded-xl bg-amber-500/15 flex items-center justify-center">
          <Ticket className="w-4 h-4 text-amber-400" strokeWidth={1.5} />
        </div>
        <div className="flex-1">
          <div className="text-xs uppercase tracking-wide text-slate-400">Van egy kupon kódod?</div>
          <input
            data-testid="voucher-code-input"
            value={code}
            onChange={(e) => setCode(e.target.value.toUpperCase())}
            placeholder="KARACSONY2026"
            className="w-full bg-anthracite-900 border border-white/10 rounded-lg p-2 text-sm font-mono focus:border-electric outline-none mt-1"
          />
        </div>
      </div>
      <button
        data-testid="voucher-redeem-submit"
        type="submit"
        disabled={busy || !code.trim()}
        className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-amber-500 hover:bg-amber-500/90 disabled:opacity-50 text-anthracite-900 font-semibold text-sm transition-all"
      >
        {busy && <Loader2 className="w-4 h-4 animate-spin" />}
        Beváltás
      </button>
    </form>
  );
}
